/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Button,
  Card,
  Dropdown,
  Flex,
  Image,
  Popover,
  Progress,
  TableColumnsType,
  Tag,
} from "antd";
import {
  DeleteIcon,
  FilterIcon,
  SelectArrow,
  TickIcon,
} from "../../../../../../atoms/CustomIcons";
import TableUi from "../../../../../../atoms/Table";
import { useRef, useState } from "react";
import { changeOrderType, CurrentProposalType } from "../../../../ducks/types";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import { MoreOutlined } from "@ant-design/icons";
import ConfirmDelete from "../../../../../../atoms/ConfirmDelete";
import { SuccessMessage } from "../../../../../../atoms/Toasts/SuccessMessage";
import { ErrorMessage } from "../../../../../../atoms/Toasts/ErrorMessage";
import { AxiosError } from "axios";
import { useAppDispatch } from "../../../../../../config/hooks";
import { PopUp } from "../../../../../../atoms/PopUp";
import {
  changeOrderById,
  UpdateChangeOrderStatus,
} from "../../../../ducks/services";
import { getContractById } from "../../../../ducks/actions";
import EmptyCard from "../../../../../../atoms/EmptyCard";
import { PAGE_LIMIT, PROPOSAL_STATUS } from "../../../../../../config/utils";

interface PropsType {
  proposalData: CurrentProposalType | undefined;
  changeOrderData: changeOrderType[] | undefined;
  contractId: string;
  currentAcceptedProposalId: string | undefined;
}

export default function TabScopePricing(props: PropsType) {
  const {
    proposalData,
    changeOrderData,
    contractId,
    currentAcceptedProposalId,
  } = props;
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const dropdownRef = useRef<HTMLButtonElement>(null);
  const location = window.location.pathname;
  const pathSegments = location.split("/");
  const companyId = pathSegments[pathSegments.length - 1];
  const [pagination, setPagination] = useState(1);
  const [limit, setLimit] = useState(PAGE_LIMIT);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [tableRecord, setTableRecord] = useState<any | null>(null);

  const [selectedRowKeys, setSelectedRowKeys] = useState<
    React.Key[] | string[]
  >([]);

  // const statusClassMap: Record<string, string> = {
  //   in_progress: "in_progress_tag",
  //   approval_pending: "approval_pending_tag",
  //   ready: "ready_tag",
  //   sent: "sent_tag",
  //   accepted: "accepted_tag",
  //   revision: "revision_red_tag",
  //   declined: "declined_red_tag",
  //   archived: "archived_grey_tag",
  // };

  // const [filters, setFilters] = useState<{
  //   type: undefined | string;
  //   status: undefined | string[];
  //   state: undefined;
  //   city: undefined;
  //   last_user_activity: string[] | undefined;
  //   onboarding_complete_date: string[] | undefined;
  //   search_text: undefined | string;
  // }>({
  //   type: undefined,
  //   status: undefined,
  //   state: undefined,
  //   city: undefined,
  //   last_user_activity: undefined,
  //   onboarding_complete_date: undefined,
  //   search_text: undefined,
  // });

  const handleStatusChange = (status: string) => {
    setLoading(true);

    const payload = {
      status: status,
    };

    if (tableRecord) {
      UpdateChangeOrderStatus(payload, tableRecord?.id)
        .then(() => {
          setLoading(false);
          dispatch(getContractById(contractId));
          setTableRecord(null);
          SuccessMessage("Status changed");
        })
        .catch((e: unknown) => {
          if (e instanceof AxiosError) {
            setLoading(false);
            ErrorMessage(
              e?.response?.data?.error?.message ?? "Something went wrong"
            );
          } else {
            setLoading(false);
            ErrorMessage("Something went wrong");
          }
        });
    }
  };

  const items = [
    {
      key: "1",
      label: (
        <>
          {tableRecord?.status === "in_progress" && (
            <Button
              type="text"
              className="no-hover"
              onClick={(e) => {
                e.stopPropagation();
                handleStatusChange("approval_pending");
                if (dropdownRef.current) {
                  dropdownRef?.current?.click();
                }
              }}
            >
              <Image
                src="/images/contracts/cursor_icon.svg"
                alt="Change"
                preview={false}
              />{" "}
              Send for approval
            </Button>
          )}
          {tableRecord?.status === "approval_pending" && (
            <Button
              type="text"
              className="no-hover"
              onClick={(e) => {
                e.stopPropagation();
                handleStatusChange("ready");
                if (dropdownRef.current) {
                  dropdownRef?.current?.click();
                }
              }}
            >
              <Image
                src="/images/potential-deals/make-copy.svg"
                alt="Change"
                preview={false}
              />{" "}
              Approve
            </Button>
          )}
          {tableRecord?.status === "ready" && (
            <Popover
              arrow={false}
              overlayClassName="status_popover"
              content={
                <ul>
                  <li>
                    <Button
                      type="text"
                      className="no-hover"
                      icon={
                        <Image
                          src="/images/potential-deals/email-icon.svg"
                          preview={false}
                        />
                      }
                      onClick={(e) => {
                        e.stopPropagation();
                        navigate(`/send-proposal/${tableRecord?.proposal_id}`);
                      }}
                    >
                      <span style={{ textAlign: "left", marginTop: "-2px" }}>
                        By email <br />
                        <span
                          style={{
                            fontSize: "12px",
                            color: "#6C7478",
                            lineHeight: "16px",
                            display: "block",
                          }}
                        >
                          Send email directly from LandScaling.
                        </span>
                      </span>
                    </Button>
                  </li>

                  <li>
                    <Button
                      type="text"
                      className="no-hover"
                      icon={
                        <Image
                          src="/images/potential-deals/link-icon.svg"
                          preview={false}
                        />
                      }
                      onClick={(e) => {
                        e.stopPropagation();
                      }}
                    >
                      <span style={{ textAlign: "left", marginTop: "-2px" }}>
                        Copy link <br />{" "}
                        <span
                          style={{
                            fontSize: "12px",
                            color: "#6C7478",
                            lineHeight: "16px",
                            display: "block",
                          }}
                        >
                          Copy the link and send it through any <br />
                          convenient method.
                        </span>
                      </span>
                    </Button>
                  </li>
                </ul>
              }
              placement="rightTop"
              getPopupContainer={(trigger) =>
                trigger.parentElement || document.body
              }
            >
              <Button type="text" className="no-hover">
                <Image
                  src="/images/potential-deals/change-status.svg"
                  alt="Move crew’s schedule"
                  preview={false}
                />{" "}
                Send to customer
              </Button>
            </Popover>
          )}
          {tableRecord?.status === "sent" && (
            <Button
              type="text"
              className="no-hover"
              onClick={(e) => {
                e.stopPropagation();
                navigate(`/send-proposal/${tableRecord?.proposal_id}`);
              }}
            >
              <Image
                src="/images/potential-deals/make-copy.svg"
                alt="Change"
                preview={false}
              />{" "}
              Send follow-up
            </Button>
          )}
          {tableRecord?.status === "accepted" && (
            <Button
              type="text"
              className="no-hover"
              onClick={(e) => {
                e.stopPropagation();
                navigate(
                  `/sent-change-order-to-production/${tableRecord?.contract_id}/${tableRecord?.proposal_id}/${proposalData?.deal_id}/${companyId}`
                );
              }}
            >
              <Image
                src="/images/potential-deals/make-copy.svg"
                alt="Change"
                preview={false}
              />{" "}
              Send to production
            </Button>
          )}
        </>
      ),
    },
    {
      key: "2",
      label: (
        <Popover
          arrow={false}
          overlayClassName="status_popover"
          content={
            <ul>
              <li>
                <Button
                  type="text"
                  className="color_popover"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleStatusChange("in_progress");
                    if (dropdownRef.current) {
                      dropdownRef?.current?.click();
                    }
                  }}
                >
                  <span
                    className="badge"
                    style={{
                      border: "1px solid #6454F4",
                      background: "#6454F4",
                    }}
                  />{" "}
                  In progress
                  {tableRecord?.status === "in_progress" && (
                    <TickIcon
                      style={{ color: "#00A07D", marginLeft: "auto" }}
                    />
                  )}
                </Button>
              </li>

              <li>
                <Button
                  type="text"
                  className="color_popover"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleStatusChange("approval_pending");
                    if (dropdownRef.current) {
                      dropdownRef?.current?.click();
                    }
                  }}
                >
                  <span
                    className="badge"
                    style={{
                      border: "1px solid #943AF5",
                      background: "#943AF5",
                    }}
                  />{" "}
                  Pending approval
                  {tableRecord?.status === "approval_pending" && (
                    <TickIcon
                      style={{ color: "#00A07D", marginLeft: "auto" }}
                    />
                  )}
                </Button>
              </li>
              <li>
                <Button
                  type="text"
                  className="color_popover"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleStatusChange("ready");
                    if (dropdownRef.current) {
                      dropdownRef?.current?.click();
                    }
                  }}
                >
                  <span
                    className="badge"
                    style={{
                      border: "1px solid #44A6F1",
                      background: "#44A6F1",
                    }}
                  />{" "}
                  Ready
                  {tableRecord?.status === "ready" && (
                    <TickIcon
                      style={{ color: "#00A07D", marginLeft: "auto" }}
                    />
                  )}
                </Button>
              </li>
              <li>
                <Button
                  type="text"
                  className="color_popover"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleStatusChange("sent");
                    if (dropdownRef.current) {
                      dropdownRef?.current?.click();
                    }
                  }}
                >
                  <span
                    className="badge"
                    style={{
                      border: "1px solid #E6C300",
                      background: "#E6C300",
                    }}
                  />{" "}
                  Sent
                  {tableRecord?.status === "sent" && (
                    <TickIcon
                      style={{ color: "#00A07D", marginLeft: "auto" }}
                    />
                  )}
                </Button>
              </li>
              <li>
                <Button
                  type="text"
                  className="color_popover"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleStatusChange("accepted");
                    if (dropdownRef.current) {
                      dropdownRef?.current?.click();
                    }
                  }}
                >
                  <span
                    className="badge"
                    style={{
                      border: "1px solid #00A07D",
                      background: "#00A07D",
                    }}
                  />{" "}
                  Accepted
                  {tableRecord?.status === "accepted" && (
                    <TickIcon
                      style={{ color: "#00A07D", marginLeft: "auto" }}
                    />
                  )}
                </Button>
              </li>
              <li>
                <Button
                  type="text"
                  className="color_popover"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleStatusChange("revision");
                    if (dropdownRef.current) {
                      dropdownRef?.current?.click();
                    }
                  }}
                >
                  <span
                    className="badge"
                    style={{
                      border: "1px solid #F06400",
                      background: "#F06400",
                    }}
                  />{" "}
                  Revision
                  {tableRecord?.status === "revision" && (
                    <TickIcon
                      style={{ color: "#00A07D", marginLeft: "auto" }}
                    />
                  )}
                </Button>
              </li>
              <li>
                <Button
                  type="text"
                  className="color_popover"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleStatusChange("declined");
                    if (dropdownRef.current) {
                      dropdownRef?.current?.click();
                    }
                  }}
                >
                  <span
                    className="badge"
                    style={{
                      border: "1px solid #CD1951",
                      background: "#CD1951",
                    }}
                  />{" "}
                  Declined
                  {tableRecord?.status === "declined" && (
                    <TickIcon
                      style={{ color: "#00A07D", marginLeft: "auto" }}
                    />
                  )}
                </Button>
              </li>
              <li>
                <Button
                  type="text"
                  className="color_popover"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleStatusChange("archived");
                    if (dropdownRef.current) {
                      dropdownRef?.current?.click();
                    }
                  }}
                >
                  <span
                    className="badge"
                    style={{
                      border: "1px solid #98A3A9",
                      background: "#98A3A9",
                    }}
                  />{" "}
                  Archived
                  {tableRecord?.status === "archived" && (
                    <TickIcon
                      style={{ color: "#00A07D", marginLeft: "auto" }}
                    />
                  )}
                </Button>
              </li>
            </ul>
          }
          placement="rightTop"
          getPopupContainer={(trigger) =>
            trigger.parentElement || document.body
          }
        >
          <Button type="text" className="no-hover">
            <Image
              src="/images/potential-deals/change-status.svg"
              alt="Move crew’s schedule"
              preview={false}
            />
            Change status to ...
          </Button>
        </Popover>
      ),
    },
    {
      key: "3",
      label: (
        <Button
          type="text"
          className="delete-hover"
          onClick={(e) => {
            e.stopPropagation();
            setIsDeleteModalOpen(true);
            if (dropdownRef.current) {
              dropdownRef?.current?.click();
            }
          }}
          icon={<DeleteIcon />}
        >
          Delete
        </Button>
      ),
    },
  ];

  const columns: TableColumnsType<changeOrderType> = [
    {
      title: "Name",
      dataIndex: "name",
      width: 270,
      render: (text) => {
        // const isLastRow = record.id === "4";
        return (
          <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
            {text ? text : "-"}
            {/* {isLastRow && (
              <img
                src="/images/potential-deals/proposal_document_yellow.svg"
                alt="icon"
                style={{ width: 23, height: 23 }}
              />
            )} */}
          </span>
        );
      },
      sorter: (a, b) => a?.name?.localeCompare(b?.name),
      fixed: "left",
    },
    {
      title: "Type",
      dataIndex: "type",
      width: 150,
      render: (text) =>
        text ? (text === "change_order" ? "Change order" : text) : "-",
      sorter: (a, b) => a?.type?.localeCompare(b?.type),
    },
    {
      title: "Change delta",
      dataIndex: "delta",
      width: 150,
      render: (text) => {
        if (text === null || text === undefined) return "-";
        const value =
          typeof text === "number"
            ? Number(text.toFixed(2)).toLocaleString()
            : text;
        return `$${value}`;
      },
    },
    {
      title: "Resulted amount",
      dataIndex: "resulted_amount",
      width: 150,
      render: (text) => {
        if (text === null || text === undefined) return "-";
        const value =
          typeof text === "number"
            ? Number(text.toFixed(2)).toLocaleString()
            : text;
        return `$${value}`;
      },
    },
    {
      title: "Resulted GM",
      dataIndex: "resulted_gross_margin",
      width: 150,
      render: (text) => {
        if (text === null || text === undefined) return "-";
        const value =
          typeof text === "number"
            ? Number(text.toFixed(2)).toLocaleString()
            : text;
        return `${value}%`;
      },
      // sorter: (a, b) =>
      //   a?.resulted_gross_margin?.localeCompare(b?.resulted_gross_margin),
    },
    {
      title: "Status",
      dataIndex: "status",
      width: 150,
      render: (text) =>
        text && PROPOSAL_STATUS[text as keyof typeof PROPOSAL_STATUS] ? (
          <Tag
            className={`${
              text === "in_progress"
                ? "in_progress_tag"
                : text === "approval_pending"
                ? "approval_pending_tag"
                : text === "ready"
                ? "ready_tag"
                : text === "sent"
                ? "sent_tag"
                : text === "accepted"
                ? "accepted_tag"
                : text === "revision"
                ? "revision_tag"
                : text === "declined" || text === "lost"
                ? "declined_red_tag"
                : text === "expired"
                ? "expired_tag"
                : text === "archived"
                ? "archived_tag"
                : "default_tag"
            } defaultTag`}
          >
            {PROPOSAL_STATUS[text as keyof typeof PROPOSAL_STATUS]}
          </Tag>
        ) : (
          "-"
        ),

      sorter: (a, b) => a?.status?.localeCompare(b?.status),
    },
    {
      title: "Date created",
      dataIndex: "date_created",
      width: 150,
      render: (text) => {
        return text ? dayjs(text).format("MM-DD-YYYY") : "-";
      },
    },
    {
      title: "",
      dataIndex: "action",
      width: 52,
      fixed: "right",
      render: (_text, record) => (
        <Dropdown
          menu={{ items }}
          trigger={["click"]}
          placement="bottomRight"
          className="actionButton"
        >
          <Button
            onClick={(e) => {
              console.log("text", record);
              setTableRecord(record);
              e.stopPropagation();
            }}
            onKeyDown={(e) => e.stopPropagation()}
            style={{
              width: "28px",
              height: "28px",
              background: "transparent",
            }}
            ref={dropdownRef}
            className="only_icon"
            icon={<MoreOutlined />}
          />
        </Dropdown>
      ),
    },
  ];

  const deleteFunction = () => {
    setLoading(true);
    changeOrderById(tableRecord?.id as string)
      .then(() => {
        setLoading(false);
        setIsDeleteModalOpen(false);
        setTableRecord(null);
        dispatch(getContractById(contractId));
        SuccessMessage("Proposal deleted");
      })
      .catch((e: unknown) => {
        if (e instanceof AxiosError) {
          setLoading(false);
          ErrorMessage(
            e?.response?.data?.error?.message ?? "Something went wrong"
          );
        } else {
          setLoading(false);
          ErrorMessage("Something went wrong");
        }
      });
  };

  const deleteProposalPopUp = {
    visibility: isDeleteModalOpen,
    content: (
      <ConfirmDelete
        title=""
        onClose={() => setIsDeleteModalOpen(false)}
        heading="Confirm deletion"
        paragraph={
          <>
            Are you sure you want to delete <b>{tableRecord?.name}</b>?
            <br /> <br />
            This action cannot be undone.
          </>
        }
        btnText="Delete"
        btnApi={deleteFunction}
        loading={loading}
      />
    ),
    width: 480,
    onCancel: () => setIsDeleteModalOpen(false),
  };

  const onClickRow = (record: changeOrderType) => {
    return {
      onClick: () => {
        navigate(
          `/edit-change-order/${currentAcceptedProposalId}/${record?.id}/${contractId}/${record?.proposal_id}/${proposalData?.deal_id}/${companyId}`
        );
      },
    };
  };

  return (
    <div className="dashboard-tab">
      <div className="scope_n_pricing" style={{ marginBottom: "16px" }}>
        <h4>
          Current scope of work
          <div style={{ backgroundColor: "#FFF1A6", borderRadius: "100px" }}>
            <img
              src="/images/potential-deals/proposal_document_yellow.svg"
              alt=""
            />
          </div>
        </h4>
        {proposalData?.modified_date && (
          <p style={{ fontSize: "12px", marginBottom: "12px" }}>
            Latest accepted -{" "}
            {dayjs(proposalData?.modified_date).format("MM-DD-YYYY")}
          </p>
        )}

        <div className="widgets">
          <Card
            onClick={() =>
              navigate(
                `/contract/estimate/${contractId}/${proposalData?.id}/${proposalData?.deal_id}/${companyId}`
              )
            }
            style={{
              cursor: "pointer",
              width: "40%",
              borderRadius: "12px",
            }}
          >
            <h6> Estimate </h6>
            <Flex gap="small" vertical style={{ marginBottom: "12px" }}>
              <Progress
                strokeColor="#00A07D"
                trailColor="#8FDFCA"
                percent={55}
                showInfo={false}
              />
            </Flex>
            <div
              style={{
                marginBottom: "2px",
                display: "flex",
                alignItems: "center",
                gap: "8px",
                justifyContent: "space-between",
              }}
            >
              <span>Gross margin:</span>
              <span style={{ fontSize: "16px", fontWeight: 700 }}>
                {proposalData?.gross_margin_perc}%
              </span>
            </div>
            <div
              style={{
                marginBottom: "2px",
                display: "flex",
                alignItems: "center",
                gap: "8px",
                justifyContent: "space-between",
              }}
            >
              <span>Total amount:</span>
              <span style={{ fontSize: "16px", fontWeight: 700 }}>
                $
                {Number(proposalData?.total_amount.toFixed(2)).toLocaleString()}
              </span>
            </div>
          </Card>
          <Card
            style={{ width: "24%", borderRadius: "12px", cursor: "pointer" }}
            onClick={() =>
              // navigate(`/change-order-document/${contractId}/${companyId}`)
              navigate(
                `/document-editor/${proposalData?.id}/${contractId}/${companyId}`
              )
            }
          >
            <img
              src="/images/potential-deals/proposal_document.svg"
              alt=""
              style={{ marginBottom: "12px" }}
            />
            <h6 style={{ marginBottom: "8px" }}> Proposal document </h6>
            <p
              style={{ color: "#474C4D", fontSize: "12px", lineHeight: "16px" }}
            >
              Latest proposal accepted by the customer
            </p>
          </Card>
          <Card
            style={{
              width: "18%",
              backgroundColor: "#D3E8FC4D",
              border: "1px solid #D3E8FC4D",
              borderRadius: "12px",
              cursor: "pointer",
            }}
            onClick={() =>
              navigate(
                `/create-upsale/${contractId}/${proposalData?.id}/${proposalData?.deal_id}/${companyId}`
              )
            }
          >
            <img
              src="/images/potential-deals/status/create_blue.svg"
              alt=""
              style={{ marginBottom: "12px" }}
            />
            <h6 style={{ marginBottom: "8px" }}> Create Upsell </h6>
            <p
              style={{ color: "#474C4D", fontSize: "12px", lineHeight: "16px" }}
            >
              Extra services to the base contract.
            </p>
          </Card>
          <Card
            onClick={() =>
              navigate(
                `/change-order/${contractId}/${proposalData?.id}/${proposalData?.deal_id}/${companyId}`
              )
            }
            style={{
              cursor: "pointer",
              width: "18%",
              backgroundColor: "#FFF9D999",
              border: "1px solid #FFF9D999",
              borderRadius: "12px",
            }}
          >
            <img
              src="/images/potential-deals/status/create_yellow.svg"
              alt=""
              style={{ marginBottom: "12px" }}
            />
            <h6 style={{ marginBottom: "8px" }}> Create change order </h6>
            <p
              style={{ color: "#474C4D", fontSize: "12px", lineHeight: "16px" }}
            >
              Scope reduction, replacements, etc.
            </p>
          </Card>
        </div>
      </div>
      <div>
        <Card
          className="scope_n_pricing table_area_scope bold_table scope_and_pricing_height"
          style={{ marginTop: 12 }}
        >
          <div className="header" style={{ marginBottom: "12px" }}>
            <h4> Change orders & upsells </h4>
            <div style={{ display: "flex", gap: "8px" }}>
              <div className="filterToggle">
                <Button
                  icon={<FilterIcon />}
                  className="outlined-btn"
                  onClick={() => console.log("Toggle filters")}
                  disabled={true}
                >
                  Filters
                  <div className="filter_icon">
                    <SelectArrow />
                  </div>
                </Button>
              </div>
              {/* <div className="filterDownload">
                <Button
                  className="outlined-btn"
                  onClick={() =>
                    navigate(
                      `/change-order/${contractId}/${proposalData?.id}/${proposalData?.deal_id}/${companyId}`
                    )
                  }
                >
                  <PlusIcon /> Change order{" "}
                </Button>
              </div> */}
            </div>
          </div>

          {(changeOrderData?.length ?? 0) > 0 ? (
            <div className="change_order_table">
              <TableUi
                columns={columns}
                data={{
                  count: changeOrderData?.length || 0,
                  data: changeOrderData || [],
                }}
                // filters={
                //   <Filters
                //     setFilters={setFilters}
                //     filters={filters}
                //     archived={archived}
                //     isArchived={isArchived}
                //   />
                // }
                pageSize={limit}
                setPageSize={setLimit}
                setCurrentPage={setPagination}
                currentPage={pagination}
                selectedRowKeys={selectedRowKeys}
                setSelectedRowKeys={setSelectedRowKeys}
                onClickRow={onClickRow}
              />
            </div>
          ) : (
            <div
              className="empty_wrap contract_empty_wrap"
              style={{ backgroundColor: "#fff", borderRadius: "12px" }}
            >
              <EmptyCard
                imageHeight={100}
                className=""
                title="No change orders"
                description={
                  <>
                    Use change orders to add upsells or make other changes to
                    the <br /> scope of work and pricing.
                  </>
                }
                image="/images/empty-icons/error-icon.svg"
                // btnText="Change order"
                // btnLink={`/change-order/${contractId}/${proposalData?.id}/${proposalData?.deal_id}/${companyId}`}
              />
            </div>
          )}
        </Card>
      </div>

      <Card
        className="scope_n_pricing table_area_scope bold_table"
        style={{
          marginTop: 12,
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div>
            <h4> Original scope </h4>
            <p> Was accepted on Jun 30 </p>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              gap: "10px",
            }}
          >
            <div
              style={{
                backgroundColor: "#fff",
                borderRadius: "12px",
                padding: "16px 24px",
              }}
            >
              <h6
                style={{
                  color: "#151718",
                  fontSize: "12px",
                  fontWeight: 500,
                  marginBottom: "4px",
                }}
              >
                Total amount
              </h6>
              <h5 style={{ fontSize: "16px", fontWeight: "700" }}>
                $
                {Number(proposalData?.total_amount.toFixed(2)).toLocaleString()}
              </h5>
            </div>
            <div
              style={{
                backgroundColor: "#fff",
                borderRadius: "8px",
                padding: "15px 20px",
              }}
            >
              <h6
                style={{
                  color: "#151718",
                  fontSize: "12px",
                  fontWeight: 500,
                  marginBottom: "4px",
                }}
              >
                Gross margin
              </h6>
              <h5 style={{ fontSize: "16px", fontWeight: "700" }}>
                {proposalData?.gross_margin_perc}%
              </h5>
            </div>
          </div>
        </div>
      </Card>

      <PopUp {...deleteProposalPopUp} />
    </div>
  );
}
